import '@css/style.scss';
const { gsap, ScrollTrigger } = window;

// scroll industries to center by default
const centerScrollElement = (selector) => {
const element = document.querySelector(selector);

if (element) {
    const scrollCenter = (element.scrollWidth - element.clientWidth) / 2;
    element.scrollLeft = scrollCenter;
}
};
// Запускаем после загрузки DOM
document.addEventListener('DOMContentLoaded', () => {
    centerScrollElement('.industries__circles');
});
window.addEventListener('resize', () => centerScrollElement('.industries__circles'));

// Industries: circles assemble in on scroll, like a constellation
document.addEventListener('DOMContentLoaded', () => {
    const section = document.getElementById('industries');
    if (!section || !gsap) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const circles = section.querySelectorAll('.industry-circle');
    if (!circles.length) return;
    gsap.from(circles, {
        scrollTrigger: { trigger: section, start: 'top 75%' },
        opacity: 0,
        scale: 0.6,
        duration: 0.5,
        ease: 'back.out(1.6)',
        stagger: { each: 0.05, from: 'random' },
    });
});

document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger);

    const revealText = document.querySelector('.js-reveal-text');
    if (revealText) {
    // 1. Разбиваем текст на символы
    const textContent = revealText.textContent.trim();
    revealText.innerHTML = textContent
        .split('')
        .map(char => `<span>${char}</span>`)
        .join('');

    const chars = revealText.querySelectorAll('span');

    // 2. Создаем анимацию GSAP
    gsap.to(chars, {
        scrollTrigger: {
        trigger: revealText,
        start: "top 80%", // Начинать, когда текст на 80% высоты экрана
        end: "top 20%",   // Закончить, когда текст поднялся выше
        scrub: true,      // Привязка анимации к скроллу
        },
        color: "#111111",   // Целевой цвет (--clr-text-light)
        opacity: 1,
        stagger: 0.1,       // Задержка между буквами
        ease: "none"
    });
    }
});
// PROCESS SECTION
document.addEventListener('DOMContentLoaded', () => {
    const showMoreBtn = document.getElementById('show-more-btn');
    const wrapper = document.querySelector('.process__wrapper');

    if ( !(wrapper instanceof HTMLElement)) {
        return;
    }
    if (showMoreBtn instanceof HTMLElement) {
        showMoreBtn.addEventListener('click', () => {
            wrapper.classList.add('is-expanded');
        });
    }

    function drawProcessLine() {
        const svg = document.getElementById('process-svg');
        const path = document.getElementById('process-path');
        const items = document.querySelectorAll('.process__item');
        // const containerRect = document.getElementById('process').getBoundingClientRect();
        // Важно: теперь берем координаты относительно wrapper, а не всей секции
        const containerRect = wrapper.getBoundingClientRect();

        if (items.length === 0) return;

        let d = "";

        const radius = 16; // 1rem = 16px

        items.forEach((item, index) => {
            const numberBox = item.querySelector('.process__number');
            const rect = numberBox.getBoundingClientRect();
            const x = rect.left + rect.width / 2 - containerRect.left;
            const y = rect.top + rect.height / 2 - containerRect.top;


            if (index === 0) {
                // v1 - от края блока
                // d += `M ${x} 0 L ${x} ${y}`;
                // v2 Линия начинается ПРЯМО из центра первого кружка, а не от края экрана
                d += `M ${x} ${y}`;
            } else {
                const prevRect = items[index - 1].querySelector('.process__number').getBoundingClientRect();
                const prevX = prevRect.left + prevRect.width / 2 - containerRect.left;
                const prevY = prevRect.top + prevRect.height / 2 - containerRect.top;
                // const midY = prevY + (y - prevY) / 2;

                // считаем по другому -- как оступ между краями блоков
                const prevBlock = items[index - 1].querySelector('.process__block');
                const currentBlock = item.querySelector('.process__block');

                const prevBottom = prevBlock.getBoundingClientRect().bottom - containerRect.top;
                const currentTop = currentBlock.getBoundingClientRect().top - containerRect.top;

                // Теперь линия всегда ПОВЕРХУ будет ровно посередине между краями блоков
                const midY = prevBottom + (currentTop - prevBottom) / 2;


                // Направление поворота (1 вправо, -1 влево)
                const dir = x > prevX ? 1 : -1;

                // 1. Линия вниз до начала первого скругления
                d += ` L ${prevX} ${midY - radius}`;
                // 2. Первое скругление (поворот на 90 градусов к горизонтали)
                d += ` Q ${prevX} ${midY} ${prevX + radius * dir} ${midY}`;
                // 3. Горизонтальная линия до начала второго скругления
                d += ` L ${x - radius * dir} ${midY}`;
                // 4. Второе скругление (поворот на 90 градусов вертикально вниз)
                d += ` Q ${x} ${midY} ${x} ${midY + radius}`;
                // 5. Линия вниз до центра номера
                d += ` L ${x} ${y}`;
            }
        });

        // Доводим линию до конца секции
        // const lastRect = items[items.length - 1].querySelector('.process__number').getBoundingClientRect();
        // const lastX = lastRect.left + lastRect.width / 2 - containerRect.left;
        // d += ` L ${lastX} ${containerRect.height}`;

        path.setAttribute('d', d);
    }

    window.addEventListener('resize', drawProcessLine);
    window.addEventListener('load', drawProcessLine);

    const ro = new ResizeObserver(entries => {
        drawProcessLine();
    });
    // v1 follow to parent
    // ro.observe(document.getElementById('process')); 
    // v2 follow to wrapper
    if (wrapper instanceof HTMLElement) {
        ro.observe(wrapper);
    }
})




/* nav area */
function toggleNavigation(){
    let toggler = document.querySelector('.nav-toggler');
    let togglerArea = document.querySelector('.nav-area');
    if (toggler instanceof HTMLElement && togglerArea instanceof HTMLElement ) {
        toggler.classList.toggle('nav-toggler--toggled');
        togglerArea.classList.toggle('nav-area--toggled');
    }
}
function closeNavigation(){
    let toggler = document.querySelector('.nav-toggler');
    let togglerArea = document.querySelector('.nav-area');
    if (toggler instanceof HTMLElement && togglerArea instanceof HTMLElement ) {
        toggler.classList.remove('nav-toggler--toggled');
        togglerArea.classList.remove('nav-area--toggled');
    }
}
let toggler = document.querySelector('.nav-toggler');
if (toggler instanceof HTMLElement) {
    toggler.addEventListener('click', function(event) {
        toggleNavigation();
    }, false);
}

/* stiky header */
let header = document.getElementById('header');
let hero = document.getElementById('hero');
if (header) {
    let gameChangerPosition = 1;
    // trigger after last hero section pixels
    if (hero instanceof HTMLElement) {
        let box = hero.getBoundingClientRect();
        gameChangerPosition = box.height - ( box.height / 6 );
    }

    ['scroll', 'resize'].forEach(function(e){
        window.addEventListener(e, function() {
            header.classList.toggle('header--sticky', window.scrollY > gameChangerPosition);
        }, false);
    });

    // initial check
    window.dispatchEvent( new Event("resize") );
}

/* smooth navigation */
function scrollToElement( element = null, hash = '', offset = 0 ) {
    if (!(element instanceof HTMLElement) && hash.length > 2 && hash.indexOf('#') >= 0) {
      element = document.querySelector( hash );
    }
    if ( element && element instanceof HTMLElement ) {
      let y = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({top: y, behavior: 'smooth'});
    }
}
document.querySelectorAll('a[href^="#"]:not([href^="#open-form-modal"]').forEach(link => {
    link.addEventListener('click', function(event){
        closeNavigation();
        event.preventDefault();
        scrollToElement(null, link.hash, 106);
    });
});

document.addEventListener('DOMContentLoaded', event => {
    if (window.location.hash) {
        scrollToElement(null, window.location.hash, 120);
    }
});

/* JS Accordion (FAQ & case inner) */
const accordions = document.querySelectorAll('.accordion');
if (accordions) {
    accordions.forEach(function (accordion) {
        let itemHeaders = accordion.querySelectorAll('.accordion__item-title');
        itemHeaders.forEach(function (item) {
            item.addEventListener('click', function (event) {
                let parent = event.target.closest('.accordion__item');
                parent.classList.toggle('accordion__item--active');
                itemHeaders.forEach(innerItem => {
                    // if (!innerItem.closest('.accordion__item').isSameNode(parent)) {
                    //     innerItem.closest('.accordion__item').classList.remove('accordion__item--active');
                    // }
                    // else {
                    //     setTimeout(()=> {
                    //         parent.classList.toggle('accordion__item--active');
                    //     }, 150);
                    // }
                })
            });
        });
    });
}

/* spoiler */
let spoiler = document.querySelector('.js-spoiler');
if (spoiler) {
    let plus = spoiler.querySelector('.spoiler__plus');
    let content = spoiler.querySelector('.spoiler__content');
    plus.addEventListener('click', function(event) {
        plus.classList.toggle('spoiler__plus--toggled');
        content.classList.toggle('spoiler__content--toggled');
    }, false);
}

/* Headaches */
document.addEventListener('DOMContentLoaded', () => {
  const prevBtn = document.querySelector('.headaches__arrow--prev');
  const nextBtn = document.querySelector('.headaches__arrow--next');
  const paginationContainer = document.querySelector('.headaches__pagination');
  
    const el = document.querySelector(`#headaches .headaches__carousel`);
    if (!el) return;
    const headachesCarousel = new Splide(el, {
      type   : 'loop',
      rewind: true,
      gap: 24,
      arrows: false,
      pagination: false,
      speed: 400,
      perPage: 3,
      breakpoints: {
        1920: {
            perPage: 3,
        },
        768: {
            perPage: 2,
        },
        575: {
            perPage: 1,
        }
      }
    }).mount();

    prevBtn.onclick = () => headachesCarousel.go('<');
    nextBtn.onclick = () => headachesCarousel.go('>');
    
    paginationContainer.innerHTML = '';
    const slides = headachesCarousel.Components.Slides.get();

    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.classList.add('splide__pagination__page');
      dot.setAttribute('type', 'button');
      dot.ariaLabel = `Go to slide ${index + 1}`;
      
      dot.addEventListener('click', () => headachesCarousel.go(index));
      paginationContainer.appendChild(dot);
    });

    const updateDots = () => {
      const dots = paginationContainer.querySelectorAll('.splide__pagination__page');
      dots.forEach((dot, idx) => {
        dot.classList.toggle('is-active', idx === headachesCarousel.index);
      });
    };

    headachesCarousel.on('move', updateDots);
    updateDots();
});

/* AI functions: Splide carousel on mobile, CSS grid on tablet/desktop */
document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('#ai-functions .ai-functions__carousel');
    if (!el || typeof Splide === 'undefined') return;
    const mq = window.matchMedia('(max-width: 767.98px)');
    let splide = null;
    const sync = () => {
        if (mq.matches && !splide) {
            splide = new Splide(el, {
                perPage: 1,
                gap: '1rem',
                arrows: false,
                pagination: false,
                padding: { right: '2rem' },   // peek of next card
            }).mount();
        } else if (!mq.matches && splide) {
            splide.destroy(true);             // revert to the CSS grid on larger screens
            splide = null;
        }
    };
    sync();
    mq.addEventListener('change', sync);
});

/* AI statement reveal — lines rise + fade in top to bottom on scroll */
document.addEventListener('DOMContentLoaded', () => {
    const section = document.getElementById('ai-statement');
    if (!section || !gsap) return;
    const lines = section.querySelectorAll('.ai-statement__line');
    if (!lines.length) return;
    gsap.from(lines, {
        scrollTrigger: { trigger: section, start: 'top 75%' },
        y: 30,
        opacity: 0,
        duration: 0.6,
        stagger: 0.15,
        ease: 'power2.out',
    });
});

/* AI outcomes carousel */
document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('#ai-outcomes .ai-outcomes__carousel');
    if (!el) return;
    const carousel = new Splide(el, {
        type: 'slide',
        rewind: true,
        gap: 24,
        arrows: false,
        pagination: false,
        speed: 400,
        perPage: 3,
        breakpoints: {
            991: { perPage: 2 },
            575: { perPage: 1 },   // mobile: one card per view (swipe)
        }
    }).mount();

    const prevBtn = document.querySelector('.ai-outcomes__arrow--prev');
    const nextBtn = document.querySelector('.ai-outcomes__arrow--next');
    if (prevBtn) prevBtn.onclick = () => carousel.go('<');
    if (nextBtn) nextBtn.onclick = () => carousel.go('>');
});

/* Reviews */
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.reviews__tab');
  const panels = document.querySelectorAll('.reviews__panel');
  const prevBtn = document.querySelector('.reviews__arrow--prev');
  const nextBtn = document.querySelector('.reviews__arrow--next');
  const paginationContainer = document.querySelector('.reviews__pagination');
  
  const instances = {};
  let currentSplide = null;

  function createCustomPagination(splideInstance) {
    paginationContainer.innerHTML = ''; // Очищаем старые точки
    
    // Создаем точки на основе количества слайдов
    const slides = splideInstance.Components.Slides.get();
    
    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.classList.add('splide__pagination__page');
      dot.setAttribute('type', 'button');
      dot.ariaLabel = `Go to slide ${index + 1}`;
      
      dot.addEventListener('click', () => splideInstance.go(index));
      paginationContainer.appendChild(dot);
    });

    // Функция обновления активной точки
    const updateDots = () => {
      const dots = paginationContainer.querySelectorAll('.splide__pagination__page');
      dots.forEach((dot, idx) => {
        dot.classList.toggle('is-active', idx === splideInstance.index);
      });
    };

    splideInstance.on('move', updateDots);
    updateDots(); // Устанавливаем начальное состояние
  }

  function initOrUpdateSlider(id) {
    panels.forEach(p => p.classList.toggle('reviews__panel--active', p.id === id));
    
    const el = document.querySelector(`#${id} .reviews__carousel`);
    if (!el) return;

    if (!instances[id]) {
      instances[id] = new Splide(el, {
        type: 'slide',
        rewind: true,
        gap: 24,
        arrows: false,
        pagination: false, // Отключаем встроенную, так как делаем свою
        speed: 400,
      }).mount();
    }

    currentSplide = instances[id];
    
    // Перепривязываем стрелки
    prevBtn.onclick = () => currentSplide.go('<');
    nextBtn.onclick = () => currentSplide.go('>');

    // Пересоздаем пагинацию для текущего слайдера
    createCustomPagination(currentSplide);
  }

  // Табы
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('reviews__tab--active'));
      tab.classList.add('reviews__tab--active');
      initOrUpdateSlider(tab.dataset.tab);
    });
  });

  // Инициализация первого таба
  initOrUpdateSlider('salesforce');
});

/* Cases */
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.cases__tab');
  const panels = document.querySelectorAll('.cases__panel');
  const prevBtn = document.querySelector('.cases__arrow--prev');
  const nextBtn = document.querySelector('.cases__arrow--next');
  const paginationContainer = document.querySelector('.cases__pagination');
  
  const instances = {};
  let currentSplide = null;

  function createCustomPagination(splideInstance) {
    paginationContainer.innerHTML = '';
    const slides = splideInstance.Components.Slides.get();
    
    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.classList.add('splide__pagination__page');
      dot.setAttribute('type', 'button');
      dot.ariaLabel = `Go to slide ${index + 1}`;
      
      dot.addEventListener('click', () => splideInstance.go(index));
      paginationContainer.appendChild(dot);
    });

    const updateDots = () => {
      const dots = paginationContainer.querySelectorAll('.splide__pagination__page');
      dots.forEach((dot, idx) => {
        dot.classList.toggle('is-active', idx === splideInstance.index);
      });
    };

    splideInstance.on('move', updateDots);
    updateDots();
  }

  function initOrUpdateSlider(id) {
    panels.forEach(p => p.classList.toggle('cases__panel--active', p.id === id));
    
    const el = document.querySelector(`#${id} .cases__carousel`);
    if (!el) return;

    if (!instances[id]) {
      instances[id] = new Splide(el, {
        type: 'slide',
        rewind: true,
        gap: 24,
        arrows: false,
        pagination: false,
        speed: 400,
      }).mount();
    }

    currentSplide = instances[id];
    
    prevBtn.onclick = () => currentSplide.go('<');
    nextBtn.onclick = () => currentSplide.go('>');

    createCustomPagination(currentSplide);
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('cases__tab--active'));
      tab.classList.add('cases__tab--active');
      initOrUpdateSlider(tab.dataset.tab);
    });
  });
  // init the first panel present (salesforce on the homepage, ai on the AI page)
  if (panels[0]) initOrUpdateSlider(panels[0].id);
});

document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('form-modal');
    const form = document.getElementById('contact-form');

    // form modal may be absent on some pages — bail out before touching it
    if (!(modal instanceof HTMLElement) || !(form instanceof HTMLFormElement)) {
        return;
    }

    const successOverlay = document.getElementById('success-overlay');
    const errorContainer = document.getElementById('form-error');
    const submitBtn = form.querySelector('.modal-form__submit');
    const spinner = form.querySelector('.modal-form__spinner');
    const btnText = form.querySelector('.modal-form__btn-text');

    // polyfill
    if (typeof HTMLDialogElement !== 'function') {
        dialogPolyfill.registerDialog(modal);
    }

    // open modal
    document.querySelectorAll('a[href="#open-form-modal"]').forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            modal.showModal();
            document.body.style.overflow = 'hidden'; // lock scroll
        });
    });

    // Закрытие
    const closeModal = () => {
        modal.close();
        document.body.style.overflow = '';
        // reset state
        setTimeout(() => {
            successOverlay.hidden = true;
            form.reset();
            errorContainer.hidden = true;
        }, 300);
    };

    modal.addEventListener('click', (e) => {
        const dialogDimensions = modal.getBoundingClientRect();
        if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom ||
            e.target.classList.contains('modal-form__close')
        ) {
            closeModal();
        }
    });

    modal.addEventListener('close', closeModal);

    // sending form
    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        // UI loading mode
        submitBtn.disabled = true;
        spinner.hidden = false;
        btnText.style.opacity = '0';
        errorContainer.hidden = true;
        submitBtn.setAttribute('data-loading', 'true');

        const formData = new FormData(form);

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: formData
            });

            const result = await response.json();

            if (result.success) {
                successOverlay.hidden = false;
            } else {
                errorContainer.textContent = result.message || 'Error occurred';
                errorContainer.hidden = false;
            }
        } catch (error) {
            errorContainer.textContent = 'Server connection error';
            errorContainer.hidden = false;
        } finally {
            submitBtn.disabled = false;
            spinner.hidden = true;
            btnText.style.opacity = '1';
            submitBtn.removeAttribute('data-loading');
        }
    });
});